var _templateObject = _taggedTemplateLiteralLoose(['\n  20% {\n    opacity: 0.2;\n  }\n  40% {\n    opacity: 0.4;\n  }\n  60% {\n    opacity: 0.6;\n  }\n  80% {\n    opacity: 0.8;\n  }\n  100% {\n    opacity: 1;\n  }\n'], ['\n  20% {\n    opacity: 0.2;\n  }\n  40% {\n    opacity: 0.4;\n  }\n  60% {\n    opacity: 0.6;\n  }\n  80% {\n    opacity: 0.8;\n  }\n  100% {\n    opacity: 1;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  background-color: ', ';\n  z-index: 8888;\n  text-align: center;\n\n  left: 0;\n  top: 0;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n\n  .loadingText {\n    font-family: \'PlayfairDisplay\';\n    font-size: 40px;\n    font-weight: bold;\n    color: #00234b;\n    ', ';\n  }\n\n  .loadingAnimation {\n    margin-top: 40px;\n    ', ';\n  }\n\n  .loadingAnimation > div {\n    width: 50px;\n    height: 6px;\n    background: #b5985b;\n    display: inline-block;\n    animation: ', ' 1.1s infinite ease-in-out both;\n    margin-right: 6px;\n    ', ';\n  }\n\n  .loadingAnimation .loadingAnimation__item1 {\n    animation-delay: -0.8s;\n  }\n\n  .loadingAnimation .loadingAnimation__item2 {\n    animation-delay: -0.6s;\n  }\n\n  .loadingAnimation .loadingAnimation__item3 {\n    animation-delay: -0.4s;\n  }\n\n  .loadingAnimation .loadingAnimation__item4 {\n    animation-delay: -0.2s;\n  }\n\n  .loadingAnimation .loadingAnimation__item5 {\n    animation-delay: -0s;\n  }\n'], ['\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  background-color: ', ';\n  z-index: 8888;\n  text-align: center;\n\n  left: 0;\n  top: 0;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n\n  .loadingText {\n    font-family: \'PlayfairDisplay\';\n    font-size: 40px;\n    font-weight: bold;\n    color: #00234b;\n    ', ';\n  }\n\n  .loadingAnimation {\n    margin-top: 40px;\n    ', ';\n  }\n\n  .loadingAnimation > div {\n    width: 50px;\n    height: 6px;\n    background: #b5985b;\n    display: inline-block;\n    animation: ', ' 1.1s infinite ease-in-out both;\n    margin-right: 6px;\n    ', ';\n  }\n\n  .loadingAnimation .loadingAnimation__item1 {\n    animation-delay: -0.8s;\n  }\n\n  .loadingAnimation .loadingAnimation__item2 {\n    animation-delay: -0.6s;\n  }\n\n  .loadingAnimation .loadingAnimation__item3 {\n    animation-delay: -0.4s;\n  }\n\n  .loadingAnimation .loadingAnimation__item4 {\n    animation-delay: -0.2s;\n  }\n\n  .loadingAnimation .loadingAnimation__item5 {\n    animation-delay: -0s;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import PropTypes from 'prop-types';
import React from 'react';
import styled, { keyframes } from 'styled-components';

var loading = keyframes(_templateObject);

export var LoadingComponentContainer = styled.main(_templateObject2, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.small && 'font-size: 28px;';
}, function (props) {
  return props.small && 'margin-top: 28px;';
}, loading, function (props) {
  return props.small && 'width: 40px; height: 4px; margin-right: 4px;';
});

LoadingComponentContainer.displayName = 'LoadingComponentContainer';

var LoadingComponentDef = function LoadingComponentDef(props) {
  return React.createElement(
    LoadingComponentContainer,
    props,
    React.createElement(
      'div',
      { className: 'loadingText' },
      props.text
    ),
    React.createElement(
      'div',
      { className: 'loadingAnimation' },
      React.createElement('div', { className: 'loadingAnimation__item1' }),
      React.createElement('div', { className: 'loadingAnimation__item2' }),
      React.createElement('div', { className: 'loadingAnimation__item3' }),
      React.createElement('div', { className: 'loadingAnimation__item4' }),
      React.createElement('div', { className: 'loadingAnimation__item5' })
    )
  );
};

LoadingComponentDef.defaultProps = {
  text: 'Loading...',
  backgroundColor: '#e2e2e2'
};

LoadingComponentDef.propTypes = process.env.NODE_ENV !== "production" ? {
  text: PropTypes.string, // Display specific text
  backgroundColor: PropTypes.string, // Background color "rgba(255, 255, 255, 0.0)"
  small: PropTypes.bool // Display small size of LoadingCompoent
} : {};

export var withLoadingComponent = function withLoadingComponent(Comp) {
  return function (props) {
    return props.loading ? React.createElement(LoadingComponentDef, null) : React.createElement(Comp, props);
  };
};

export var LoadingComponent = LoadingComponentDef;